import React from 'react';

import { IconProps } from '../Icon.types';

export const VisibilityOffIcon = (props: IconProps) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      color={props.color}
      viewBox="0 0 18 13"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.96409 2.50008C8.54988 2.50183 8.21268 2.16746 8.21093 1.75325C8.20918 1.33904 8.54354 1.00184 8.95775 1.00009C11.004 0.995764 13.1048 1.55116 14.8761 2.57766C16.5665 3.55736 18 5.06774 18 7C18 8.00302 17.6069 8.90114 17.0013 9.6586C16.7427 9.98212 16.2707 10.0347 15.9472 9.77605C15.6237 9.5174 15.5711 9.04544 15.8298 8.72192C16.2721 8.1686 16.5 7.59112 16.5 7C16.5 5.86976 15.6418 4.75514 14.1239 3.87546C12.5824 2.9821 10.7449 2.49632 8.96409 2.50008Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.12393 11.4223C4.84342 12.4189 7.03582 13 9 13C10.6051 13 12.3554 12.6123 13.8731 11.9338L14.7197 12.7803C15.0126 13.0732 15.4874 13.0732 15.7803 12.7803C16.0732 12.4874 16.0732 12.0126 15.7803 11.7197L4.28033 0.21967C3.98744 -0.0732233 3.51256 -0.0732233 3.21967 0.21967C2.92678 0.512563 2.92678 0.987437 3.21967 1.28033L4.04335 2.10401C3.06903 2.54898 2.17342 3.1239 1.4732 3.81589C0.606432 4.67246 0 5.75167 0 7C0 8.93226 1.43347 10.4426 3.12393 11.4223ZM7.5 7C7.5 7.82843 8.17157 8.5 9 8.5C9.39878 8.5 9.76122 8.34438 10.0299 8.09056L7.90944 5.9701C7.65562 6.23878 7.5 6.60122 7.5 7ZM6 7C6 8.65685 7.34315 10 9 10C9.813 10 10.5505 9.6766 11.0908 9.15143L12.7252 10.7859C11.5236 11.2443 10.2017 11.5 9 11.5C7.29751 11.5 5.36491 10.9874 3.87607 10.1245C2.3582 9.24486 1.5 8.13024 1.5 7C1.5 6.26893 1.85091 5.5515 2.52757 4.8828C3.18791 4.23023 4.121 3.66551 5.18727 3.24793L6.84857 4.90923C6.3234 5.44953 6 6.187 6 7Z"
        fill={props.color}
      />
    </svg>
  );
};
